import React from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';

interface IGoogleMapsMapComponentProps {
    center: google.maps.LatLngLiteral;
    zoom: number;
    children: any;
};
  
const GoogleMapsMapComponent = (props: IGoogleMapsMapComponentProps) : JSX.Element => {
    return (
        <LoadScript googleMapsApiKey="AIzaSyA2-EgpVNYnyqrNqNa_fvj5uG-07_hShbk">
            <GoogleMap zoom={props.zoom} center={props.center}>
                { props.children }
            </GoogleMap>
        </LoadScript>
    );
};

export default GoogleMapsMapComponent;
